import API_CONFIG from '../config/api';
import { apiDelete, apiGet, apiPost, apiRequest } from './api';

const leerJson = async (response) => {
  const data = await response.json();
  if (data && data.success === false) {
    throw new Error(data.error || 'Error inesperado del servidor');
  }
  return data;
};

const patch = (endpoint, body) => apiRequest(endpoint, {
  method: 'PATCH',
  body: JSON.stringify(body),
});

export const previsualizarMarcasLiftingCast = async (url, tipoEvento) => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.MARCAS.PREVISUALIZAR, {
    url,
    tipo_evento: tipoEvento,
  });
  return leerJson(response);
};

export const enviarMarcasLiftingCast = async (url, tipoEvento) => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.MARCAS.ENVIAR, {
    url,
    tipo_evento: tipoEvento,
  });
  return leerJson(response);
};

export const buscarMarcas = async (buscar) => {
  const params = new URLSearchParams();
  if (buscar) params.set('buscar', buscar);
  const qs = params.toString();
  const response = await apiGet(`${API_CONFIG.ENDPOINTS.MARCAS.LISTAR}${qs ? `?${qs}` : ''}`);
  const data = await leerJson(response);
  return data.items || [];
};

export const actualizarMarca = async (rut, body) => {
  const response = await patch(API_CONFIG.ENDPOINTS.MARCAS.ACTUALIZAR(rut), body);
  return leerJson(response);
};

export const listarPropuestas = async () => {
  const response = await apiGet(API_CONFIG.ENDPOINTS.MARCAS.PROPUESTAS);
  const data = await leerJson(response);
  return data.items || [];
};

export const editarPropuesta = async (id, body) => {
  const response = await patch(API_CONFIG.ENDPOINTS.MARCAS.PROPUESTA(id), body);
  return leerJson(response);
};

export const descartarPropuesta = async (id) => {
  const response = await apiDelete(API_CONFIG.ENDPOINTS.MARCAS.PROPUESTA(id));
  return leerJson(response);
};

export const getMisPropuestas = async () => {
  const response = await apiGet(API_CONFIG.ENDPOINTS.MARCAS.MIAS);
  return leerJson(response);
};

export const aceptarMisMarcas = async () => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.MARCAS.ACEPTAR, {});
  return leerJson(response);
};

export const rechazarMisMarcas = async () => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.MARCAS.RECHAZAR, {});
  return leerJson(response);
};
